import { render, staticRenderFns } from "./textBookDetails.vue?vue&type=template&id=095e5ee4&scoped=true&"
import script from "./textBookDetails.vue?vue&type=script&lang=js&"
export * from "./textBookDetails.vue?vue&type=script&lang=js&"
import style0 from "./textBookDetails.vue?vue&type=style&index=0&id=095e5ee4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095e5ee4",
  null
  
)

export default component.exports